export default __webpack_public_path__ + "static/Visit-Santa-Claus-Village-32621bb47af1105874951abfd90218a0.jpg";